import api from "./api";

class TagsService {
  async get(filters = {}) {
    let params = "?";
    const { search, tag, limit } = filters;
    if (limit) params += "limit=" + limit + "&";
    if (search) params += "search=" + search + "&";
    if (tag) params += "tag=" + tag + "&";

    return api
      .get(`v1/api/contents/tags${params}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}

export default new TagsService();
